module.exports = __webpack_public_path__ + "img/lagerausbildung-1bohrung.c9173d50.jpg";